import { Component, signal } from '@angular/core';
import { environment } from '@environments/environment';

@Component({
  selector: 'cgw-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent {
  private today = new Date();

  private dateRanges = {
    nvidia: { start: new Date(2025, 1, 14), end: new Date(2025, 2, 15, 23, 59) },
    pricesBomb: { start: new Date(2025, 1, 20), end: new Date(2025, 3, 31, 23, 55) },
  };

  public isValidDateNvidia = signal<boolean>(false);
  public isValidDatePricesBomb = signal<boolean>(false);

  public isExperimentalDev = environment.experimentalDev;

  constructor() {
    this.isValidDateNvidia.set(this.isWithinRange(this.dateRanges.nvidia));
    this.isValidDatePricesBomb.set(this.isWithinRange(this.dateRanges.pricesBomb));
  }

  private isWithinRange(range: { start: Date; end: Date }): boolean {
    return (
      this.today.getTime() > range.start.getTime() && this.today.getTime() < range.end.getTime()
    );
  }
}
